// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoBox[data-v-3883b7d3] .el-drawer__header{margin-bottom:0;font-size:20px}.infoBox[data-v-3883b7d3] .el-icon-arrow-down,.infoBox[data-v-3883b7d3]  .el-icon-arrow-up{display:none}", ""]);
// Exports
module.exports = exports;
